module.exports = "/img/_/_/_/assets/images/creeper/book/common//27.jpg?3fbec87cf51f016d901f08de4907cbf2";